





















































































import { Component, Vue } from 'vue-property-decorator'
import { Message } from 'element-ui'
import { QueryCouponTemplateList, SaveCouponTemplate, GrantUserCoupon } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component
export default class CouponTemplateManage extends Vue {
  private tableData: any[] = []
  private editVisible = false
  private grantVisible = false
  private form: any = {}
  private grantForm: any = { userId: '', count: 1, note: '' }
  private grantTemplateId: number | null = null
  private thresholdYuan = 0
  private reductionYuan = 0
  private maxDiscountYuan = 0
  private validityType: 'DAYS' | 'FIXED' = 'DAYS'
  private validityFixedRange: Date[] | null = null

  mounted() {
    this.load()
  }

  private async load() {
    this.tableData = (await QueryCouponTemplateList({})) || []
  }

  private ruleText(row: any) {
    if (row.couponType === 'FULL_REDUCTION') {
      return `满${((row.thresholdFen || 0) / 100).toFixed(2)}减${((row.reductionFen || 0) / 100).toFixed(2)}`
    }
    if (row.couponType === 'DISCOUNT') {
      return `${row.discountPercent}%实付`
    }
    return ''
  }

  private validDaysText(days: number) {
    if (days === 1) return '1天'
    if (days === 7) return '7天'
    if (days === 30) return '30天'
    return '永久'
  }

  private validityText(row: any) {
    if (row.validStartTime && row.validEndTime) {
      return `${DateFormat(row.validStartTime)} ~ ${DateFormat(row.validEndTime)}`
    }
    return '领取后' + this.validDaysText(row.validDaysAfterGrant)
  }

  private openEdit(row?: any) {
    if (row) {
      this.form = { ...row, enabled: !!row.enabled, validDaysAfterGrant: row.validDaysAfterGrant == null ? 0 : row.validDaysAfterGrant }
      this.thresholdYuan = (row.thresholdFen || 0) / 100
      this.reductionYuan = (row.reductionFen || 0) / 100
      this.maxDiscountYuan = (row.maxDiscountFen || 0) / 100
      if (row.validStartTime && row.validEndTime) {
        this.validityType = 'FIXED'
        this.validityFixedRange = [new Date(row.validStartTime), new Date(row.validEndTime)]
      } else {
        this.validityType = 'DAYS'
        this.validityFixedRange = null
      }
    } else {
      this.form = {
        couponType: 'FULL_REDUCTION',
        enabled: true,
        totalQuota: 0,
        perUserLimit: 0,
        validDaysAfterGrant: 7
      }
      this.thresholdYuan = 0
      this.reductionYuan = 1
      this.maxDiscountYuan = 0
      this.validityType = 'DAYS'
      this.validityFixedRange = null
    }
    this.editVisible = true
  }

  private async save() {
    const payload: any = {
      ...this.form,
      thresholdFen: Math.round(this.thresholdYuan * 100),
      reductionFen: Math.round(this.reductionYuan * 100),
      maxDiscountFen: this.maxDiscountYuan > 0 ? Math.round(this.maxDiscountYuan * 100) : null
    }
    if (this.validityType === 'FIXED') {
      if (!this.validityFixedRange || this.validityFixedRange.length !== 2) {
        Message.warning('请选择固定有效期')
        return
      }
      payload.validStartTime = this.validityFixedRange[0]
      payload.validEndTime = this.validityFixedRange[1]
      payload.validDaysAfterGrant = 0
    } else {
      payload.validStartTime = null
      payload.validEndTime = null
    }
    await SaveCouponTemplate(payload)
    Message.success('已保存')
    this.editVisible = false
    this.load()
  }

  private openGrant(row: any) {
    this.grantTemplateId = row.id
    this.grantForm = { userId: '', count: 1, note: '' }
    this.grantVisible = true
  }

  private async grant() {
    if (!this.grantTemplateId || !this.grantForm.userId) {
      Message.warning('请填写用户ID')
      return
    }
    await GrantUserCoupon({
      userId: Number(this.grantForm.userId),
      couponTemplateId: this.grantTemplateId,
      count: this.grantForm.count,
      note: this.grantForm.note
    })
    Message.success('发放成功')
    this.grantVisible = false
    this.load()
  }
}
